import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RequestService from "../services/RequestService";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userId: Number | String,
    typeCall: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      requestService: new RequestService(),
      message: ""
    };
  },
  computed: {
    requirementDefs: function requirementDefs() {
      if (this.typeCall === "name") {
        return [{
          tag: "#name",
          description: "Nome do paciente",
          required: true
        }, {
          tag: "#local",
          description: "Local de atendimento",
          required: true
        }, {
          tag: "?priority",
          description: 'Marca a chamada como prioritária (vira "Prioritário")',
          required: false
        }];
      }
      if (this.typeCall === "code") {
        return [{
          tag: "#code",
          description: "Código/senha",
          required: true
        }, {
          tag: "#place",
          description: "Nome do local",
          required: true
        }, {
          tag: "#stand",
          description: "Guichê/número",
          required: true
        }, {
          tag: "?priority",
          description: 'Marca a chamada como prioritária (vira "Prioritária")',
          required: false
        }];
      }
      return [];
    },
    requirements: function requirements() {
      var lowerMessage = this.message.toLowerCase();
      return this.requirementDefs.map(function (req) {
        return _objectSpread(_objectSpread({}, req), {}, {
          satisfied: lowerMessage.indexOf(req.tag) !== -1
        });
      });
    },
    dialogTitle: function dialogTitle() {
      if (this.typeCall === "name") return "Nova mensagem de chamada por Nome";
      if (this.typeCall === "code") return "Nova mensagem de chamada por Código";
      if (this.typeCall === "local") return "Novo local";
      return "Nova mensagem";
    },
    error: function error() {
      var requiredTags = this.requirementDefs.filter(function (req) {
        return req.required;
      }).map(function (req) {
        return req.tag;
      });
      if (!requiredTags.length) return this.message.trim() === "";
      var lowerMessage = this.message.toLowerCase();
      return requiredTags.some(function (tag) {
        return lowerMessage.indexOf(tag) === -1;
      });
    }
  },
  watch: {
    value: function value(isOpen) {
      if (isOpen) {
        this.message = "";
      }
    }
  },
  methods: {
    persist: function persist() {
      var _this = this;
      if (this.error || this.message.trim() === "") return;
      if (this.typeCall !== "local") {
        var payload = {
          id: null,
          clientId: this.$props.userId,
          callBy: this.$props.typeCall,
          message: this.message.toLowerCase()
        };
        this.$root.$emit("saving-message", true, payload);
        this.requestService.saveMessage(payload).then(function (_ref) {
          var data = _ref.data;
          payload.id = data;
          _this.$root.$emit("hide-dialog");
          _this.$root.$emit("saving-message", false, {
            error: false
          });
          _this.message = "";
        }).catch(function (err) {
          _this.$root.$emit("saving-message", false, {
            error: true
          });
          alert("Erro ao salvar menssagem");
        });
      } else {
        var _payload = {
          id: null,
          clientId: this.$props.userId,
          name: this.message
        };
        this.$root.$emit("saving-message", {
          condition: true,
          type: "placeName"
        }, _payload);
        this.requestService.savePlace(_payload).then(function (_ref2) {
          var data = _ref2.data;
          _payload.id = data;
          _this.$root.$emit("hide-dialog");
          _this.$root.$emit("saving-message", false, {
            error: false
          });
          _this.message = "";
        }).catch(function (err) {
          _this.$root.$emit("saving-message", false, {
            error: true
          });
          alert("Erro ao salvar");
        });
      }
    },
    cancel: function cancel() {
      this.$root.$emit("hide-dialog", true);
      this.message = "";
    }
  }
};